function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1972(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 72.3,
    height: 40.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.15,
    y: 20.01,
    fontFamily: "Arial"
  }, "\n        Greenlee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.02,
    width: 72.3,
    height: 42.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.15,
    y: 61.175000000000004,
    fontFamily: "Arial"
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.33,
    width: 72.3,
    height: 61.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.15,
    y: 113.155,
    fontFamily: "Arial"
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 143.98,
    width: 72.3,
    height: 70.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.15,
    y: 178.98999999999998,
    fontFamily: "Arial"
  }, "\n        Apache\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 214,
    width: 72.3,
    height: 101.67,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.049999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.15,
    y: 264.835,
    fontFamily: "Arial"
  }, "\n        Mohave\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 315.67,
    width: 72.3,
    height: 107.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.15,
    y: 369.46500000000003,
    fontFamily: "Arial"
  }, "\n        Gila\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 423.26,
    width: 72.3,
    height: 120.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.049999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.15,
    y: 483.28,
    fontFamily: "Arial"
  }, "\n        Navajo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 543.3,
    width: 72.3,
    height: 156.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.15,
    y: 621.65,
    fontFamily: "Arial"
  }, "\n        Yuma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.3,
    y: 0,
    width: 150.45,
    height: 85.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.71125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.52499999999998,
    y: 42.845,
    fontFamily: "Arial"
  }, "\n        Coconino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.76,
    y: 0,
    width: 153.69,
    height: 85.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.137999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.605,
    y: 42.845,
    fontFamily: "Arial"
  }, "\n        Pinal\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.45,
    y: 0,
    width: 160.17,
    height: 85.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.241428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.53499999999997,
    y: 42.845,
    fontFamily: "Arial"
  }, "\n        Cochise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.61,
    y: 0,
    width: 163.39,
    height: 85.69,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.241428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.3050000000001,
    y: 42.845,
    fontFamily: "Arial"
  }, "\n        Yavapai\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.3,
    y: 85.69,
    width: 196.71,
    height: 614.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 49.1775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.655,
    y: 392.84499999999997,
    fontFamily: "Arial"
  }, "\n        Pima\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.01,
    y: 85.69,
    width: 430.99,
    height: 614.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 53.87375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.505,
    y: 392.84499999999997,
    fontFamily: "Arial"
  }, "\n        Maricopa\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1972);
export default __webpack_public_path__ + "static/media/1972.472fd9078da9dcee0534d3db8c760daa.svg";
export { ForwardRef as ReactComponent };